import {
  ActionType,
  EditableFormInstance,
  EditableProTable,
  ProCard,
  ProColumns,
  ProForm,
  ProFormInstance,
} from '@ant-design/pro-components';
import { Form, Space, Table } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
// icons
import CustomProTable from 'base/ui/components/CustomTable';
import * as Icon from 'base/ui/components/Icons';
import CustomDatePicker from 'base/ui/components/Input/customDatePicker';
import CustomInputString from 'base/ui/components/Input/customInputString';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { useTranslation } from 'react-i18next';
import { SYSTEM_TITLE } from 'utils/constants';
import { AiFillAlipayCircle } from 'react-icons/ai';

type DataType = Partial<{
  key: string;
  stt: number;
  // id
  taskCode: string;
  // tiêu đề
  summary: string;
  taskStatus: string;
  // mã khách hàng
  profileName: string;
  profileCode: string;
  phone: string;
  // liên hệ khách hành
  primaryContact: string;
  sdtPrimaryContact: string;
  // phân loại khách hàng
  customerTypeName: string;
  // ngày ghé thăm
  visitDate: string;
  // thời gian gửi
  sendTime: string;
  // trạng thái gửi tin
  statusSendMes: string;
  // gửi thành công hay thất bại
  isSuccess: boolean | null;
}>;
const dataSource: DataType[] = [
  {
    key: '1',
    stt: 1,
    taskCode: '10497101',
    summary: 'Đào Phương Thảo-06/06-Chị Quyên',
    taskStatus: 'Đã hoàn thành',
    // mã khách hàng
    profileName: 'Chị Quyên',
    profileCode: '100451837',
    phone: '0963240423',
    // liên hệ khách hành
    primaryContact: 'Chị Quyên',
    sdtPrimaryContact: '0963240423',
    // phân loại khách hàng
    customerTypeName: 'Tiêu dùng',
    // ngày ghé thăm
    visitDate: '',
    // thời gian gửi
    sendTime: '',
    // trạng thái gửi tin
    statusSendMes: 'Đã gửi',
    // gửi thành công hay thất bại
    isSuccess: false,
  },
  {
    key: '2',
    stt: 2,
    taskCode: '10497102',
    summary: 'Thùy Dung-06/06-Đức Châm',
    taskStatus: 'Chưa hoàn thành',
    // mã khách hàng
    profileName: 'Nội Thất Đức Châm',
    profileCode: '100409499',
    phone: '0978325275',
    // liên hệ khách hành
    primaryContact: 'Anh Toàn',
    sdtPrimaryContact: '0933009148',
    // phân loại khách hàng
    customerTypeName: 'Doanh nghiệp',
    // ngày ghé thăm
    visitDate: '',
    // thời gian gửi
    sendTime: '',
    // trạng thái gửi tin
    statusSendMes: 'Chưa gửi',
    // gửi thành công hay thất bại
    isSuccess: null,
  },
  {
    key: '3',
    stt: 3,
    taskCode: '10497103',
    summary: 'Thu Thủy-06/06-Xhome',
    taskStatus: 'Đã hoàn thành',
    // mã khách hàng
    profileName: 'Công ty Cổ Phần Nội Thất Thông Minh Xhome Việt Nam',
    profileCode: '100002997',
    phone: '0909314455',
    // liên hệ khách hành
    primaryContact: 'Thu Thủy',
    sdtPrimaryContact: '0833777331',
    // phân loại khách hàng
    customerTypeName: 'Doanh nghiệp',
    // ngày ghé thăm
    visitDate: '',
    // thời gian gửi
    sendTime: '',
    // trạng thái gửi tin
    statusSendMes: 'Đã gửi',
    // gửi thành công hay thất bại
    isSuccess: true,
  },
];

// KHÁCH HÀNG GHÉ THĂM
export function createAppointmentPage() {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.appointment') + ' - ' + SYSTEM_TITLE;
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [selectRows, setSelectRows] = useState<DataType[]>([]);
    const defaultColumn: ProColumns<DataType>[] = [
      // stt
      {
        title: t('customer.appointment.stt'),
        dataIndex: 'stt',
        key: 'stt',
        align: 'center',
        width: 50,
      },
      // id
      {
        title: 'id',
        dataIndex: 'taskCode',
        key: 'taskCode',
        align: 'left',
        width: 100,
      },
      //  Tiêu đề
      {
        title: t('customer.appointment.title'),
        dataIndex: 'summary',
        key: 'summary',
      },
      // Trạng thái
      {
        title: t('customer.appointment.status'),
        dataIndex: 'taskStatus',
        key: 'taskStatus',
        width: 150,
      },
      // Mã khách hàng
      {
        title: t('customer.appointment.customer-code'),
        dataIndex: 'profileCode',
        key: 'profileCode',
        width: 150,
      },
      // Khách hàng
      {
        title: t('customer.appointment.customer'),
        dataIndex: 'profileName',
        key: 'profileName',
      },
      // Số điện thoại
      {
        title: t('customer.appointment.phone'),
        dataIndex: 'phone',
        key: 'phone',
        width: 100,
      },
      // Liên hệ ghé thăm
      {
        title: t('customer.appointment.contact-visit'),
        dataIndex: 'primaryContact',
        key: 'primaryContact',
        width: 150,
      },
      // SĐT Liên hệ ghé thăm
      {
        title: t('customer.appointment.phone-contact'),
        dataIndex: 'sdtPrimaryContact',
        key: 'sdtPrimaryContact',
        width: 150,
      },
      // Phân loại khách hàng
      {
        title: t('customer.appointment.customer-class'),
        dataIndex: 'customerTypeName',
        key: 'customerTypeName',
        width: 150,
      },
      // Ngày ghé thăm
      {
        title: t('customer.appointment.visit-date'),
        dataIndex: 'visitDate',
        key: 'visitDate',
        width: 100,
      },
      // Thời gian gửi
      {
        title: t('customer.appointment.send-time'),
        dataIndex: 'sendTime',
        key: 'sendTime',
        width: 100,
      },
      // Trạng thái gửi tin
      {
        title: t('customer.appointment.status-send-mes'),
        dataIndex: 'statusSendMes',
        key: 'statusSendMes',
        width: 100,
      },
      // Gửi thành công/thất bại
      {
        title: t('customer.appointment.is-success'),
        dataIndex: 'isSuccess',
        key: 'isSuccess',
        width: 150,
        render: (text, record) => {
          return text === true ? 'Gửi Thành công' : text === false ? 'Gửi Thất bại' : '';
        },
      },
    ];
    // Custom default columns table with resizeable
    const [columns, setColumns] = useState<ProColumns<DataType>[]>(defaultColumn);
    // ============================================== FUNCTION ===================================================//
    const showDrawer = () => {
      setOpen(true);
    };
    const onClose = () => {
      setOpen(false);
    };
    // Function handle resize columns
    const handleResize =
      (index: number) =>
        (e: any, { size }: any) => {
          // Set columns
          setColumns((prevColumns) => {
            const nextColumns = [...prevColumns];
            nextColumns[index] = {
              ...nextColumns[index],
              width: size.width,
            };
            return nextColumns;
          });
        };

    return (
      // KHÁCH HÀNG GHÉ THĂM
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.appointment'),
          },
        ]}
        extras={
          <>
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Icon.Filter className="!fill-primary" />
            </CustomButton>
            <CustomButton type="primary">{t('btn.send-message')}</CustomButton>
          </>
        }
      >
        {/* Form search */}
        <BoxContainer fullHeight>
          <CustomProTable<DataType>
            columns={columns}
            handleResize={handleResize}
            rowSelection={{
              selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT],
              onChange(selectedRowKeys, selectedRows, info) {
                setSelectRows(selectedRows);
              },
            }}
            size="small"
            dataSource={dataSource}
            scroll={{ x: 2500, y: 500 }}
            search={false}
            pagination={{
              pageSize: 5,
            }}
            rowKey="key"
            tableAlertOptionRender={() => {
              return null;
            }}
            tableAlertRender={({ selectedRowKeys, selectedRows, onCleanSelected }) => {
              return (
                <Space size={24}>
                  <span>
                    {t('message.selected')} {selectedRowKeys.length} {t('message.item')}
                    <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                      {t('btn.cancel-selection')}
                    </a>
                  </span>
                </Space>
              );
            }}
          />
        </BoxContainer>

        <SearchBox onClose={onClose} open={open}>
          <SearchForm form={form}>
            {/* id */}
            <SearchItem label={'ID'} name={'taskCode'}>
              <CustomInputString />
            </SearchItem>
            {/* khách hàng */}
            <SearchItem label={t('search-form.customer-name')} name={'profileName'}>
              <CustomInputString />
            </SearchItem>
            {/* Công ty* */}
            <SearchItem label={t('search-form.company')} name={'saleOrg'}>
              <CustomInputString />
            </SearchItem>
            {/* Chi nhánh */}
            <SearchItem label={t('search-form.branch')} name={'branch'}>
              <CustomInputString />
            </SearchItem>
            {/* Phân loại khách hàng */}
            <SearchItem label={t('search-form.customer-class')} name={'customerType'}>
              <CustomInputString />
            </SearchItem>
            {/* Trạng thái gửi tin */}
            <SearchItem label={t('search-form.send-status')} name={'sendStatus'}>
              <CustomInputString />
            </SearchItem>
            {/* SĐT liên hệ */}
            <SearchItem label={t('search-form.phone-contact')} name={'phoneContact'}>
              <CustomInputString />
            </SearchItem>
            {/* Kết quả gửi tin */}
            <SearchItem label={t('search-form.send-results')} name={'resultSend'}>
              <CustomInputString />
            </SearchItem>
            {/* Ngày ghé thăm từ */}
            <SearchItem label={`${t('search-form.date-visit-from')}`} name={'dateFrom'}>
              <CustomDatePicker />
            </SearchItem>
            {/* Ngày ghé thăm đến */}
            <SearchItem label={`${t('search-form.date-visit-to')}`} name={'dateTo'}>
              <CustomDatePicker />
            </SearchItem>

            <div className="col-span-4 sticky bottom-[-24px] py-2 bg-white w-full">
              <CustomButton htmlType="submit" className="my-auto" type="primary">
                {t('btn.search')}
              </CustomButton>
            </div>
          </SearchForm>
        </SearchBox>
      </PageWrapper>
    );
  });
}

export default createAppointmentPage;
